module.exports = __webpack_public_path__ + "img/idea1.70bf948c.png";